import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    //console.error('Error in lazy-loaded component:', error, info);
  }

  render() {
    if (this.state.hasError) {
      // Render nothing on error
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
